<template>
  <div class="pageBox ptb80" :style="{background:' url('+activeBg+') no-repeat center top'}">
    <div class="wap clearfix">
      <left-menu :data="leftMenu" :id.sync="activeNodeId"></left-menu>
      <div class="rnrBox">
        <div class="Crumbs ft30 clearfix animation srcospcur">
          <h4>
            <img src="/static/about/mxico1.png" />
            <a href="/" title>首页</a> &gt;
            <router-link
              v-if="leftMenu.length>0"
              :to="{name:'about',params:{pId:$route.params.pId,cId:leftMenu[0].nodeId}}"
              id="firsturl"
              title
            >经营发展</router-link>&gt;
            <span>{{activeName}}</span>
          </h4>
          <h3>{{activeName}}</h3>
        </div>
        <template v-if="contentData&&contentData.length>0">
          <m-map v-if="activeNodeIndexName=='map'" :data="contentData"></m-map>
          <m-brace v-if="activeNodeIndexName=='brace'" :data="contentData"></m-brace>
          <m-change v-if="activeNodeIndexName=='change'" :data="contentData"></m-change>
          <m-develop v-if="activeNodeIndexName=='history'" :data="contentData"></m-develop>
          <m-achievement v-if="activeNodeIndexName=='achievement'" :data="contentData"></m-achievement>
          <m-honor v-if="activeNodeIndexName=='honor'" :data="contentData"></m-honor>
        </template>
        <template v-else>
          <div class="no-data">暂无数据</div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import mMap from "./child/map";
import mBrace from "./child/brace";
import mChange from "./child/change";
import mDevelop from "./child/develop";
import mAchievement from "./child/achievement";
import mHonor from "./child/honor";
import { getNewsList } from "@/api/index";
export default {
  components: { mMap, mBrace, mChange, mDevelop, mAchievement, mHonor },
  data() {
    return {
      leftMenu: [],
      activeNodeId: "",
      activeName: "",
      contentData: null,
      activeNodeIndexName: "",
      activeBg: "/static/20181206105614.jpg"
    };
  },
  watch: {
    $route: function(newVal) {
      this.activeNodeId = newVal.params.cId;
      this.leftMenu.forEach(item => {
        if (item.nodeId == newVal.params.cId) {
          this.activeName = item.nodeName;
          this.activeNodeIndexName = item.nodeIndexName;
          this.activeBg = item.imageUrl || "/static/20181206105614.jpg";
        }
      });
      this.getNewsListFun({
        pageNo: 0,
        pageSize: 999,
        condition: {
          nodeId: newVal.params.cId
        }
      });
    }
  },
  created() {
    // let menus = JSON.parse(localStorage.bwsteelMenus);
    let path = this.$route.params;

    let menuData = this.$utils.getMenuCellByNodeIndexName("development");
    this.activeNodeId = path.cId;
    menuData.childs.forEach(item => {
      if (item.nodeId == path.cId) {
        this.activeName = item.nodeName;
        this.activeNodeIndexName = item.nodeIndexName;
        this.activeBg = item.imageUrl || "/static/20181206105614.jpg";
      }
    });
    this.getNewsListFun({
      pageNo: 0,
      pageSize: 999,
      condition: {
        nodeId: this.activeNodeId
      }
    });
    this.$set(this.$data, "leftMenu", menuData.childs);
  },
  methods: {
    // 获取二级列表内容
    getNewsListFun(json) {
      getNewsList(json).then(res => {
        if (res.data.code == 1000) {
          this.$set(this.$data, "contentData", res.data.data.data);
        }
      });
    }
  }
};
</script>